<div class="approval-flow-container">
  <h2>{{ 'approval.flow.management' | translate }}</h2>

  <!-- 錯誤訊息 -->
  <div *ngIf="error" class="error-message">
    {{ error }}
    <button (click)="error = null" class="close-btn">×</button>
  </div>

  <!-- 載入中 -->
  <div *ngIf="loading" class="loading">
    {{ 'sds.loading' | translate }}
  </div>

  <div class="approval-flow-management-layout">
    <!-- 左側清單 -->
    <div class="flow-list-panel">
      <div class="panel-header">
        <h3>{{ 'approval.flow.list' | translate }}</h3>
        <button (click)="startCreateFlow()" class="btn btn-primary">
          {{ 'approval.flow.add_flow' | translate }}
        </button>
      </div>

      <div class="flow-list">
        <div *ngFor="let flow of flowDefinitions"
             class="flow-item"
             [class.active]="selectedFlow?.id === flow.id"
             (click)="selectFlow(flow)">
          <span class="flow-name">{{ flow.name }}</span>
          <span class="flow-status" [class.active]="flow.status === 'active'">
            {{ flow.status === 'active' ? ('approval.flow.enabled' | translate) : ('approval.flow.disabled' | translate) }}
          </span>
        </div>

        <div *ngIf="flowDefinitions.length === 0 && !loading" class="no-flows">
          {{ 'approval.flow.no_flows' | translate }}
        </div>
      </div>
    </div>

    <!-- 右側詳細資訊 -->
    <div class="flow-detail-panel">
      <!-- 查看模式 -->
      <div *ngIf="selectedFlow && !isEditingFlow && !isCreatingNew" class="view-mode">
        <div class="panel-header">
          <h3>{{ selectedFlow.name }}</h3>
          <div class="button-group">
            <button (click)="startEditFlow()" class="btn btn-secondary">{{ 'approval.flow.edit' | translate }}</button>
            <button (click)="deleteFlow(selectedFlow)" class="btn btn-danger">{{ 'approval.flow.delete' | translate }}</button>
          </div>
        </div>

        <div class="flow-info">
          <div class="info-row">
            <span class="label">{{ 'approval.flow.description' | translate }}</span>
            <span class="value">{{ selectedFlow.description || ('approval.flow.none' | translate) }}</span>
          </div>

          <div class="info-row">
            <span class="label">{{ 'approval.flow.status' | translate }}</span>
            <span class="value status" [class.active]="selectedFlow.status === 'active'">
              {{ selectedFlow.status === 'active' ? ('approval.flow.enabled' | translate) : ('approval.flow.disabled' | translate) }}
            </span>
          </div>

        </div>

        <div class="flow-steps">
          <h4>{{ 'approval.flow.steps' | translate }}</h4>

          <div *ngIf="selectedFlow.steps.length === 0" class="no-steps">
            {{ 'approval.flow.no_steps' | translate }}
          </div>

          <div *ngFor="let step of selectedFlow.steps; let i = index" class="step-item">
            <div class="step-header">
              <div class="step-number">{{ i + 1 }}</div>
              <div class="step-name">{{ step.name }}</div>
              <div class="step-optional" *ngIf="step.optional">{{ 'approval.flow.optional' | translate }}</div>
            </div>

            <div class="step-details">
              <div class="detail-row">
                <span class="label">{{ 'approval.flow.approver' | translate }}</span>
                <span class="value">
                  {{ step.approverType === 'role_based' ? ('approval.flow.role_based' | translate) : ('approval.flow.specific_user' | translate) }}
                </span>
              </div>

              <div class="detail-row" *ngIf="step.approverType === 'role_based'">
                <span class="label">{{ 'approval.flow.department_role' | translate }}</span>
                <span class="value">
                  <span *ngIf="step.isDynamicDepartment" class="dynamic-department">{{ step.departmentName }}</span>
                  <span *ngIf="!step.isDynamicDepartment">{{ step.departmentName }}</span>
                  - {{ getRoleTranslatedName(step.roleId || '') }}
                </span>
              </div>

              <div class="detail-row" *ngIf="step.approverType === 'specific_user'">
                <span class="label">{{ 'approval.flow.specified_person' | translate }}</span>
                <span class="value">{{ step.userName }}</span>
              </div>

              <!-- <div class="detail-row">
                <span class="label">{{ 'approval.flow.require_comment' | translate }}</span>
                <span class="value">{{ step.requireComment ? ('form.list.yes' | translate) : ('common.no' | translate) }}</span>
              </div> -->

              <!-- <div class="detail-row">
                <span class="label">{{ 'approval.flow.require_signature' | translate }}</span>
                <span class="value">{{ step.requireSignature ? ('form.list.yes' | translate) : ('common.no' | translate) }}</span>
              </div> -->

              <!-- 自訂表單欄位顯示 -->
              <div class="detail-row" *ngIf="step.customFormItems && step.customFormItems.length > 0">
                <span class="label">{{ 'approval.flow.required_fields_count' | translate }}:  </span>
<span class="value"> {{ step.customFormItems.length }}</span>

                <!-- <div class="value">
                  <div class="custom-form-items-list">
                    <div *ngFor="let item of step.customFormItems; let idx = index" class="custom-form-item-view">
                      <span class="item-number">{{ idx + 1 }}.</span>
                      <span class="item-label">{{ item.label || (('approval.flow.component_prefix' | translate) + ' ' + (idx + 1)) }}</span>
                      <span class="item-type-badge">{{ getFormItemTypeDisplay(item.type) }}</span>
                      <span class="required-indicator" *ngIf="item.required">*</span>
                    </div>
                  </div>
                </div> -->
              </div>

              <div class="detail-row" *ngIf="!step.customFormItems || step.customFormItems.length === 0">
                <span class="label">{{ 'approval.flow.custom_form_fields' | translate }}</span>
                <span class="value text-muted">
                  <i class="fas fa-info-circle"></i>
                  {{ 'approval.flow.no_custom_form_fields' | translate }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 編輯/新增模式 -->
      <div *ngIf="(isEditingFlow && selectedFlow) || isCreatingNew" class="edit-mode">
        <div class="panel-header">
          <h3>{{ isCreatingNew ? ('approval.flow.add_new_flow' | translate) : ('approval.flow.edit_flow' | translate) }}</h3>
          <div class="button-group">
            <button (click)="saveFlow()" class="btn btn-primary">{{ 'approval.flow.save' | translate }}</button>
            <button (click)="cancelEdit()" class="btn btn-secondary">{{ 'form.list.cancel' | translate }}</button>
          </div>
        </div>

        <div class="flow-form">
          <div class="form-group">
            <label for="flowName">{{ 'approval.flow.flow_name' | translate }} <span class="required">{{ 'approval.flow.required' | translate }}</span></label>
            <input
              type="text"
              id="flowName"
              [ngModel]="currentFlow.name"
              (ngModelChange)="updateFlowName($event)"
              required
              class="form-control"
              [placeholder]="'approval.flow.enter_flow_name' | translate"
            >
          </div>

          <div class="form-group">
            <label for="flowDescription">{{ 'approval.flow.flow_description' | translate }}</label>
            <textarea
              id="flowDescription"
              [ngModel]="currentFlow.description"
              (ngModelChange)="updateFlowDescription($event)"
              class="form-control"
              [placeholder]="'approval.flow.enter_flow_description' | translate"
            ></textarea>
          </div>

          <div class="form-group">
            <label>{{ 'approval.flow.flow_status' | translate }}</label>
            <div class="radio-group">
              <label class="radio-label">
                <input
                  type="radio"
                  value="active"
                  [checked]="currentFlow.status === 'active'"
                  (change)="updateFlowStatus('active')"
                >
                {{ 'approval.flow.enable' | translate }}
              </label>
              <label class="radio-label">
                <input
                  type="radio"
                  value="inactive"
                  [checked]="currentFlow.status === 'inactive'"
                  (change)="updateFlowStatus('inactive')"
                >
                {{ 'approval.flow.disable' | translate }}
              </label>
            </div>
          </div>


          <div class="form-group steps-section">
            <div class="section-header">
              <label>{{ 'approval.flow.steps' | translate }}</label>
              <button (click)="addStep()" class="btn btn-sm btn-primary">{{ 'approval.flow.add_step' | translate }}</button>
            </div>

            <div class="steps-list">
              <div *ngIf="currentFlow.steps.length === 0" class="no-steps">
                {{ 'approval.flow.no_steps_added' | translate }}
              </div>

              <div *ngFor="let step of currentFlow.steps; let i = index" class="step-edit-item">
                <div class="step-edit-header">
                  <div class="step-number">{{ i + 1 }}</div>
                  <input
                    type="text"
                    [(ngModel)]="step.name"
                    class="form-control step-name-input"
                    [placeholder]="'approval.flow.step_name' | translate"
                  >
                  <div class="step-actions">
                    <button (click)="moveStepUp(i)" class="btn btn-sm btn-icon" [disabled]="i === 0">↑</button>
                    <button (click)="moveStepDown(i)" class="btn btn-sm btn-icon" [disabled]="i === (currentFlow.steps.length - 1)">↓</button>
                    <button (click)="removeStep(i)" class="btn btn-sm btn-icon btn-danger">×</button>
                  </div>
                </div>

                <div class="step-edit-body">
                  <div class="form-group">
                    <label>{{ 'approval.flow.approver_type' | translate }}</label>
                    <div class="radio-group">
                      <label class="radio-label">
                        <input
                          type="radio"
                          value="role_based"
                          [checked]="step.approverType === 'role_based'"
                          (change)="updateApproverType(step, 'role_based')"
                        >
                        {{ 'approval.flow.assign_by_role' | translate }}
                      </label>
                      <label class="radio-label">
                        <input
                          type="radio"
                          value="specific_user"
                          [checked]="step.approverType === 'specific_user'"
                          (change)="updateApproverType(step, 'specific_user')"
                        >
                        {{ 'approval.flow.assign_specific' | translate }}
                      </label>
                    </div>
                  </div>

                  <!-- 如果是依角色指派 -->
                  <div *ngIf="step.approverType === 'role_based'" class="role-based-options">
                    <div class="form-group">
                      <label for="department_{{i}}">{{ 'form.list.department' | translate }}</label>
                      <select
                        id="department_{{i}}"
                        [(ngModel)]="step.departmentId"
                        (change)="onDepartmentChangeSelect(step, $event)"
                        class="form-control"
                      >
                        <option value="">{{ 'approval.flow.select_department' | translate }}</option>
                        <!-- 動態部門選項 -->
                        <optgroup [label]="'approval.flow.dynamic_department' | translate">
                          <option value="submitter_dept">{{ 'approval.flow.same_submitter_dept' | translate }}</option>
                          <option value="parent_dept">{{ 'approval.flow.parent_dept' | translate }}</option>
                        </optgroup>
                        <optgroup [label]="'approval.flow.fixed_department' | translate">
                          <option *ngFor="let department of departments" [value]="department.id">
                            {{ getDepartmentDisplayName(department) }}
                          </option>
                        </optgroup>
                      </select>
                    </div>

                    <div class="form-group">
                      <label for="role_{{i}}">{{ 'approval.flow.role' | translate }}</label>
                      <select
                        id="role_{{i}}"
                        [(ngModel)]="step.roleId"
                        (change)="onRoleChangeSelect(step, $event)"
                        class="form-control"
                        [disabled]="!step.departmentId"
                      >
                        <option value="">{{ 'approval.flow.select_role' | translate }}</option>
                        <option *ngFor="let role of filteredRoles" [value]="role.id">
                          {{ getRoleTranslatedName(role.id) }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <!-- 如果是指定人員 -->
                  <div *ngIf="step.approverType === 'specific_user'" class="specific-user-options">
                    <div class="form-group">
                      <label for="user_{{i}}">{{ 'approval.flow.person' | translate }}</label>
                      <select
                        id="user_{{i}}"
                        [(ngModel)]="step.userId"
                        (change)="onUserChangeSelect(step, $event)"
                        class="form-control"
                      >
                        <option value="">{{ 'approval.flow.select_person' | translate }}</option>
                        <option *ngFor="let user of users" [value]="user.id">
                          {{ user.name }} {{ user.departmentId ? '(' + getDepartmentName(user.departmentId) + ')' : '' }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="step-options">
                    <!-- 移除基本的 checkbox，將功能整合到進階設定中 -->
                    <!-- <div class="integrated-settings-info">
                      <p class="help-text">
                        <i class="fas fa-info-circle"></i>
                        {{ 'approval.flow.integrated_settings_help' | translate }}
                      </p>
                    </div> -->



                  <!-- 簽核步驟設定預覽區域 -->
                  <div class="step-preview-section">
                    <div class="step-preview-header">
                      <h6><i class="fas fa-eye"></i> {{ 'approval.flow.approval_display_content' | translate }}</h6>
                    </div>
                    <div class="step-preview-content">
                      <!-- 基本簽核要求 -->
                      <div class="basic-requirements" *ngIf="step.requireComment || step.requireSignature">
                        <div class="requirement-item" *ngIf="step.requireComment">
                          <i class="fas fa-comment text-primary"></i>
                          <span>{{ 'approval.flow.require_comment_text' | translate }}</span>
                        </div>
                        <div class="requirement-item" *ngIf="step.requireSignature">
                          <i class="fas fa-signature text-primary"></i>
                          <span>{{ 'approval.flow.require_signature_text' | translate }}</span>
                        </div>
                      </div>

                      <!-- 自訂表單元件預覽 -->
                      <div class="custom-form-preview" *ngIf="step.customFormItems && step.customFormItems.length > 0">
                        <div class="custom-form-header">
                          <i class="fas fa-forms text-warning"></i>
                          <span>{{ 'approval.flow.custom_form_with_count' | translate:{ count: step.customFormItems.length } }}</span>
                        </div>
                        <div class="form-items-list">
                          <div *ngFor="let item of step.customFormItems; let idx = index" class="form-item-preview">
                            <span class="item-number">{{ idx + 1 }}.</span>
                            <span class="item-label">{{ item.label || (('approval.flow.component_prefix' | translate) + ' ' + (idx + 1)) }}</span>
                            <span class="item-type">{{ getFormItemTypeDisplay(item.type) }}</span>
                            <span class="required-indicator" *ngIf="item.required">*</span>
                          </div>
                        </div>
                      </div>

                      <!-- 如果沒有任何設定 -->
                      <div class="no-settings" *ngIf="!hasStepSettings(step)">
                        <i class="fas fa-info-circle text-muted"></i>
                        <span class="text-muted">{{ 'approval.flow.basic_approval_only' | translate }}</span>
                      </div>
                    </div>
                  </div>

                  <!-- 進階設定面板 -->
                  <div class="advanced-settings-panel" *ngIf="step.hasAdvancedSettings && isEditingStep(step, i)">
                    <div class="advanced-panel-header">
                      <h5><i class="fas fa-cogs"></i> {{ 'approval.flow.step_custom_form_settings' | translate }}</h5>
                      <p class="help-text">{{ 'approval.flow.custom_form_description' | translate }}</p>
                    </div>

                    <!-- 快速設定選項 -->
                    <div class="quick-settings-section">
                      <h6><i class="fas fa-bolt"></i> {{ 'approval.flow.quick_settings' | translate }}</h6>
                      <div class="quick-settings-controls">
                        <label class="checkbox-label">
                          <input type="checkbox"
                                 #commentCheckbox
                                 [checked]="step.requireComment"
                                 (change)="onRequireCommentChange(step, commentCheckbox.checked)">
                          <i class="fas fa-comment"></i>
                          {{ 'approval.flow.require_comment_input' | translate }}
                        </label>
                        <label class="checkbox-label">
                          <input type="checkbox"
                                 #signatureCheckbox
                                 [checked]="step.requireSignature"
                                 (change)="onRequireSignatureChange(step, signatureCheckbox.checked)">
                          <i class="fas fa-signature"></i>
                          {{ 'approval.flow.require_signature_input' | translate }}
                        </label>
                      </div>
                      <p class="help-text">
                        <i class="fas fa-info-circle"></i>
                        {{ 'approval.flow.quick_settings_help' | translate }}
                      </p>
                    </div>

                    <!-- 嵌入簡化版 form-builder -->
                    <div class="form-builder-container">
                      <app-form-builder
                        mode="approval-step"
                        [simplifiedUI]="true"
                        [hideAdvancedFeatures]="true"
                        [allowedComponents]="approvalStepAllowedComponents"
                        [formItems]="getStepFormBuilderItems(step)"
                        (formItemsChange)="setStepFormBuilderItems(step, $event)">
                      </app-form-builder>
                    </div>

                    <!-- 預覽按鈕 -->
                    <div class="preview-section">
                      <button type="button"
                              class="btn btn-info btn-sm"
                              (click)="previewStepForm(step, i)">
                        <i class="fas fa-eye"></i> {{ 'approval.flow.preview_approval_form' | translate }}
                      </button>
                    </div>
                  </div>
                   <!-- 進階設定按鈕 -->
                    <div class="advanced-settings-section">
                      <button type="button"
                              class="btn btn-outline-secondary btn-sm advanced-settings-btn"
                              (click)="toggleAdvancedSettings(step, i)">
                        <i class="fas fa-cogs"></i>
                        {{ step.hasAdvancedSettings ? ('approval.flow.close_advanced_settings' | translate) : ('approval.flow.advanced_settings' | translate) }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 如果沒有選擇流程且不在新增模式 -->
      <div *ngIf="!selectedFlow && !isCreatingNew" class="no-selection">
        <p>{{ 'approval.flow.no_selection' | translate }}</p>
      </div>
    </div>
  </div>
</div>

<!-- 預覽模態視窗 -->
<div class="preview-modal" *ngIf="showPreviewModal" (click)="closePreviewModal()">
  <div class="preview-modal-content" (click)="$event.stopPropagation()">
    <div class="preview-modal-header">
      <h4><i class="fas fa-eye"></i> {{ 'approval.flow.approval_form_preview' | translate }}</h4>
      <button class="close-btn" (click)="closePreviewModal()">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="preview-modal-body">
      <div class="preview-info" *ngIf="previewStepData">
        <p><strong>{{ 'approval.flow.step_label' | translate }}</strong>{{ previewStepData.name }}</p>
        <p><strong>{{ 'approval.flow.description_label' | translate }}</strong>{{ 'approval.flow.preview_interface_description' | translate }}</p>
      </div>

      <div class="preview-form-container" *ngIf="previewStepData?.customFormItems">
        <!-- 模擬簽核介面 -->
        <div class="mock-approval-interface">
          <div class="mock-approval-header">
            <h5>{{ 'approval.flow.approval_operations' | translate }}</h5>
            <p>{{ 'approval.flow.custom_form_content' | translate }}</p>
          </div>

          <!-- 直接顯示表單欄位，不透過 dynamic-form 的 preview 模式 -->
          <div class="custom-form-preview-fields">
            <div *ngFor="let field of previewStepData?.customFormItems" class="form-group custom-form-field">

              <!-- 文字輸入 -->
              <div *ngIf="field.type === 'text-input'" class="form-field">
                <label [for]="field.id">
                  {{ field.label }}
                  <span *ngIf="field.required" class="required-mark">*</span>
                </label>
                <input
                  type="text"
                  [id]="field.id"
                  [name]="field.name"
                  [placeholder]="field.placeholder || ''"
                  class="form-control"
                  [required]="field.required || false"
                  disabled>
              </div>

              <!-- 文字區塊 -->
              <div *ngIf="field.type === 'textarea'" class="form-field">
                <label [for]="field.id">
                  {{ field.label }}
                  <span *ngIf="field.required" class="required-mark">*</span>
                </label>
                <textarea
                  [id]="field.id"
                  [name]="field.name"
                  [placeholder]="field.placeholder || ''"
                  class="form-control"
                  rows="4"
                  [required]="field.required || false"
                  disabled>
                </textarea>
              </div>

              <!-- 下拉選單 -->
              <div *ngIf="field.type === 'select'" class="form-field">
                <label [for]="field.id">
                  {{ field.label }}
                  <span *ngIf="field.required" class="required-mark">*</span>
                </label>
                <select
                  [id]="field.id"
                  [name]="field.name"
                  class="form-control"
                  [required]="field.required || false"
                  disabled>
                  <option value="">{{ 'approval.flow.please_select' | translate }}</option>
                  <option *ngFor="let option of field.options" [value]="option.value">
                    {{ option.label }}
                  </option>
                </select>
              </div>

              <!-- 數字輸入 -->
              <div *ngIf="field.type === 'number-input'" class="form-field">
                <label [for]="field.id">
                  {{ field.label }}
                  <span *ngIf="field.required" class="required-mark">*</span>
                </label>
                <input
                  type="number"
                  [id]="field.id"
                  [name]="field.name"
                  [placeholder]="field.placeholder || ''"
                  class="form-control"
                  [required]="field.required || false"
                  disabled>
              </div>

              <!-- 日期選擇 -->
              <div *ngIf="field.type === 'date'" class="form-field">
                <label [for]="field.id">
                  {{ field.label }}
                  <span *ngIf="field.required" class="required-mark">*</span>
                </label>
                <input
                  type="date"
                  [id]="field.id"
                  [name]="field.name"
                  class="form-control"
                  [required]="field.required || false"
                  disabled>
              </div>

              <!-- 簽名 -->
              <div *ngIf="field.type === 'signature'" class="form-field">
                <label [for]="field.id">
                  {{ field.label }}
                  <span *ngIf="field.required" class="required-mark">*</span>
                </label>
                <div class="signature-preview-placeholder">
                  <i class="fas fa-signature"></i>
                  <span>{{ 'approval.flow.signature_area_preview' | translate }}</span>
                </div>
              </div>

              <!-- 多選框 -->
              <div *ngIf="field.type === 'multi-checkbox'" class="form-field">
                <label>
                  {{ field.label }}
                  <span *ngIf="field.required" class="required-mark">*</span>
                </label>
                <div class="checkbox-group">
                  <div *ngFor="let option of field.options" class="checkbox-item">
                    <label class="checkbox-label">
                      <input type="checkbox" disabled>
                      {{ option.label }}
                    </label>
                  </div>
                </div>
              </div>

              <!-- 單選按鈕 -->
              <div *ngIf="field.type === 'radiobutton'" class="form-field">
                <label>
                  {{ field.label }}
                  <span *ngIf="field.required" class="required-mark">*</span>
                </label>
                <div class="radio-group">
                  <div *ngFor="let option of field.options" class="radio-item">
                    <label class="radio-label">
                      <input type="radio" [name]="field.name" disabled>
                      {{ option.label }}
                    </label>
                  </div>
                </div>
              </div>

              <!-- 檔案上傳 -->
              <div *ngIf="field.type === 'file-upload-manager'" class="form-field">
                <label>
                  {{ field.label }}
                  <span *ngIf="field.required" class="required-mark">*</span>
                </label>
                <div class="file-upload-preview-placeholder">
                  <i class="fas fa-cloud-upload-alt"></i>
                  <span>{{ 'approval.flow.file_upload_area_preview' | translate }}</span>
                </div>
              </div>

              <!-- 其他類型的欄位可以在這裡添加 -->
              <div *ngIf="!['text-input', 'textarea', 'select', 'number-input', 'date', 'signature', 'multi-checkbox', 'radiobutton', 'file-upload-manager'].includes(field.type)" class="form-field">
                <label>
                  {{ field.label }}
                  <span *ngIf="field.required" class="required-mark">*</span>
                </label>
                <div class="field-preview-placeholder">
                  <i class="fas fa-question-circle"></i>
                  <span>{{ getFormItemTypeDisplay(field.type) }} {{ 'approval.flow.preview_mode' | translate }}</span>
                </div>
              </div>

            </div>
          </div>

          <div class="mock-action-buttons">
            <button class="btn btn-success" disabled>
              <i class="fas fa-check"></i> {{ 'approval.flow.approve' | translate }}
            </button>
            <button class="btn btn-danger" disabled>
              <i class="fas fa-times"></i> {{ 'approval.flow.reject' | translate }}
            </button>
          </div>
        </div>
      </div>

      <div class="no-custom-form" *ngIf="!previewStepData?.customFormItems || previewStepData?.customFormItems?.length === 0">
        <p><i class="fas fa-info-circle"></i> {{ 'approval.flow.no_custom_form_configured' | translate }}</p>
      </div>
    </div>

    <div class="preview-modal-footer">
      <button class="btn btn-secondary" (click)="closePreviewModal()">
        {{ 'approval.flow.close_preview' | translate }}
      </button>
    </div>
  </div>
</div>
